/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {AlarmeFormComponent} from "./alarme-form/alarme-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";
import {AlarmeListComponent} from "./alarme-list/alarme-list.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class AlarmeRoutingModule {}

export const alarmeRoutes: any[] = [
    {
        path: '',
        component: AlarmeListComponent
    },{
        path: editRoute + '/:id',
        component: AlarmeFormComponent
    },{
        path: newRoute,
        component: AlarmeFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/alarmes-routing.module.ts
 **/